import { render } from "./QRCodeGenerator.vue?vue&type=template&id=34b88421"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__